// /* jshint ignore:start */
// (function () {
//     'use strict';
//     angular.module('HeroPRO')
//       .service('optionsPopupService',

export default function OptionsPopupService() {
    let _popupData = null;

    let _letterGroupedOptions = null;

    this.setPopupData = function (popupData) {
        _popupData = popupData;
        _letterGroupedOptions = groupOptionsByLetter(popupData.alphabeticalOptions);
    };

    this.getPopupData = function () {
        return _popupData;
    };

    this.letterGroupedOptions = function () {
        return _letterGroupedOptions;
    };

    // Display letter if it's a new letter and has options present
    function groupOptionsByLetter(options) {
        const letterGroupedOptions = [];
        let letterIndex = 0;

        // Get first letter of attribute
        function grabFirstLetter(name) {
            return name && name.charAt(0);
        }


        function pushNewGroup(letterGroupedOptions, options) {
            letterGroupedOptions.push({
                letterHead: grabFirstLetter(options[i].DisplayName),
                letterOptions: [],
            });
        }

        function pushGroupCategories(letterGroupedOptions, options) {
            letterGroupedOptions[letterIndex].letterOptions.push({
                DisplayName: options[i].DisplayName,
                optionID: options[i].optionID,
                isChecked: options[i].isChecked,
            });
        }

        for (var i = 0; i < options.length; i++) {
            // for first option
            if (i === 0) {
                pushNewGroup(letterGroupedOptions, options);
                pushGroupCategories(letterGroupedOptions, options);
            }

            // if second option has a different letter
            else if ((i > 0 && letterIndex === 0) && (grabFirstLetter(options[i].DisplayName) !== grabFirstLetter(options[i - 1].DisplayName))) {
                letterIndex += 1;
                pushNewGroup(letterGroupedOptions, options);
                pushGroupCategories(letterGroupedOptions, options);
                letterIndex += 1;
            }

            // if second option
            else if (i > 0 && letterIndex === 0) {
                pushGroupCategories(letterGroupedOptions, options);
                letterIndex += 1;
            }

            // if option starts with a new letter, create a new letter group
            else if (grabFirstLetter(options[i].DisplayName) !== grabFirstLetter(options[i - 1].DisplayName)) {
                pushNewGroup(letterGroupedOptions, options);
                pushGroupCategories(letterGroupedOptions, options);
                letterIndex += 1;
            }

            // if option has the same letter as the previous, add it to current letter object's array
            else {
                letterGroupedOptions[letterIndex - 1].letterOptions.push({
                    DisplayName: options[i].DisplayName,
                    optionID: options[i].optionID,
                    isChecked: options[i].isChecked,
                });
            }
        }
        return letterGroupedOptions;
    }
}



// WEBPACK FOOTER //
// ./src/app/productCenter/services/optionPopupService.js